// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_25nf6","hidden":"JsGog","buttonWrapper":"_1haGN","downloadButton":"_1KMbJ","icon_small":"_1s7Np","iconSmall":"_1s7Np","icon_big":"_2PQ9y","iconBig":"_2PQ9y"};